export default "__VITE_ASSET__B6Qw_xXi__"